<template>
<wt-paged-table ref="table" class="pt-gene-lab-order-table__withData" :on-request-data="onLoadData" :current-page="currentPage" :total-size="Number(totalNumber)"
:page-size="pageSize" :isAddPageToRouter="isAddPageToRouter" :isOutside="isOutside"  layout="total,sizes, prev, pager, next,jumper" :pageSizes="[10, 20, 50, 200]">
  <el-table :data='tableData' stripe style="width: 100%" :class="classes" @selection-change="handleSelectionChange" :row-key="getRowKeys" ref="multipleTable" :row-class-name="setRed" :max-height="tableHeight">
    <template v-if="isShowCheckbox">
					<el-table-column
					type="selection"
					width="55"
          fixed="left"
					:reserve-selection="true">
				</el-table-column>
		</template>
    <lab-order-column :showFields="showFields" slot="append" @updateLabcode="updateLabcode" :showCopy="showCopy"></lab-order-column>
		<el-table-column label="操作" fixed="right" min-width="100" v-if="isShow('操作')">
      <template slot-scope="scope">
				<slot :row="scope.row"></slot>
			</template>
		</el-table-column>
	</el-table>
  </wt-paged-table>
</template>

<script>
// 组件class前缀
import labOrderColumn from 'cps/lab-order/process/form/components-with-data/lab-order-column'
import orderFlow from '@/config/order'
const prefixCls = 'pt-gene-lab-order-table'
export default {
  name: 'pt-gene-lab-order-table',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    page () {
      return this.$refs.table.page
    }
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    isShowCheckbox: {
      type: Boolean,
      default: false
    },
    showFields: {
      type: Array,
      default: () => []
    },
    pageSize: {
      type: Number
    },
    totalNumber: {
      type: [Number, String]
    },
    currentPage: {
      type: Number
    },
    isOutside: {
      type: Boolean,
      default: false
    },
    isAddPageToRouter: {
      type: Boolean,
      default: true
    },
    showCopy: {
      type: Boolean,
      default: false
    }
  },
  // inheritAttrs: true,
  data () {
    return {
      orderFlowHelper: orderFlow,
      selected: [],
      tableHeight: null
    }
  },
  components: {
    labOrderColumn
  },
  methods: {
    setRed ({ row, rowIndex }) {
      let status = this.orderFlowHelper.formatOrderActions(row.nextOrderAction)
      let nowDate = new Date()
      if (row.warningDate && nowDate >= row.warningDate) {
        return 'red'
      } else {
        if (row.remainingDays !== null && row.remainingDays <= 3 && status !== '已完成' && row.orderStatusEnum !== 'CLOSED') {
          return 'red'
        }
      }
      return ''
    },
    resetPage () {
      this.$refs.table.resetPage()
    },
    getRowKeys (row) {
      return row.id
    },
    updateLabcode (val) {
      this.selected.forEach((e, i) => {
        if (e.id === val.id) {
          this.selected[i] = val
          this.$emit('updateSelectedData', this.selected)
        }
      })
    },
    handleSelectionChange (val) {
      // let data = []
      // this.tableData.forEach(item => {
      //   val.forEach(etem => {
      //     if (item.id === etem.id) {
      //       data.push(item)
      //     }
      //   })
      // })
      this.selected = val
      this.$emit('updateSelectedData', val)
    },
    isShow (label) {
      return this.showFields.indexOf(label) > -1
    },
    onLoadData (page, next, size) {
      this.$emit('get-data-list', page, next, size)
    },
    reload () {
      this.$refs.table.load()
    },
    showReTry () {
      this.$refs.table.showReTry()
    },
    goHistoryOrder (data) {
      this.$router.push({ path: `lab-order-detail/${data.id}` })
    },
    clearSelection () {
      this.$refs.multipleTable.clearSelection()
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200

      // 监听窗口大小变化
      let self = this
      window.onresize = function () {
        self.tableHeight = window.innerHeight - self.$refs.multipleTable.$el.offsetTop - 200
      }
    })
    // this.$refs.multipleTable.$el.offsetTop：表格距离浏览器的高度
    // 150表示你想要调整的表格距离底部的高度
  }
}
</script>

<style lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-gene-lab-order-table__withData{
  .red{
    color: red;
  }
}
</style>
